module.exports = __webpack_public_path__ + "media/clip-intro-cristian.b72ce221.mp4";